import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PilaresPesvService {
  private apiUrl = `${environment.apiUrl}/api/pilares-pesv`;

  constructor(private http: HttpClient) { }

  getAllPilares(): Observable<any[]> {
    return this.http.get<any[]>(this.apiUrl);
  }

  getPilarById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/${id}`);
  }

  createPilar(data: any): Observable<any> {
    return this.http.post<any>(this.apiUrl, data);
  }

  updatePilar(id: number, data: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, data);
  }

  deletePilar(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`);
  }
}